<template>
  <ion-card
    @click="goToPost(post.slug)"
    class="border-default no-shadow post-card ion-no-margin bg-white"
    color="light"
  >
    <div class="pa-md">
      <ion-card-content
        class="ion-no-padding post-content d-flex flex-column justify-space-between"
      >
        <h1 class="blue-darker font-lg bold-medium">{{ post.name }}</h1>

        <div class="align-center gap-sm d-flex font-xxs">
          <ion-avatar class="avatar-card"
            ><img class="author-card" :alt="post.author.name" :src="post.author.picture.url"
          /></ion-avatar>

          <p>
            {{ post.author.name }} {{ t('post.in') }} {{ post['main-category'].name }}
            {{ t('post.at') }}
            {{ formatDateTime(post.createdOn as string, locale, true, true) }}
          </p>
        </div>
      </ion-card-content>
    </div>
    <img
      class="post-card-img"
      :src="
        post['thumbnail-image'].url ?? 'https://st-web.lodgerin.com/images/image-not-found.webp'
      "
    />
  </ion-card>
</template>
<script setup lang="ts">
  import { IonCardContent, IonCard, IonAvatar } from '@ionic/vue';
  import { useI18n } from 'vue-i18n';
  import { VisiblePost } from '@/interfaces/webflow/webflow.interface';
  import { formatDateTime } from '@/utils/date-utils';

  const { t, locale } = useI18n();

  withDefaults(
    defineProps<{
      post: VisiblePost;
    }>(),
    {},
  );

  const goToPost = (slug: string) => {
    const url = `https://www.lodgerin.com/${locale.value === 'es' ? 'es/' : ''}public/posts/${slug}`;
    window.open(url, '_blank');
  };
</script>
<style lang="css" scoped>
  .post-card {
    cursor: pointer;
    border: 1px solid #e3e4e7;
  }

  .post-card-img {
    height: 256px;
    width: 100%;
    min-width: 320px;
    object-fit: cover;
    margin-bottom: -4px;
  }

  .post-content {
    height: 200px;
  }

  ion-card.ion-color .ion-inherit-color,
  ion-card-header.ion-color .ion-inherit-color {
    color: inherit;
    padding-bottom: 0px !important;
  }

  .author-card {
    width: 24px;
    height: 24px;
  }

  .avatar-card {
    width: 44px;
    height: 34px;
  }
</style>
